/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Gacurabwenge 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gihinga": ["Kagarama", "Kambyeyi", "Karama", "Nyagasozi", "Nyarunyinya", "Ryabitana"],
  "Gihira": ["Bugaba", "Kibanza", "Kidaturwa", "Migina", "Nyabitare"],
  "Kigembe": ["Buhoro", "Kabatsi", "Kagarama", "Mushimba", "Nyakabungo", "Rugobagoba"],
  "Nkingo": ["Juru", "Kamonyi", "Mataba", "Nyamiryango", "Nyamugari", "Rubona"]
};